
import { Sheet, SheetContent } from '@/components/ui/sheet';
import EmailSidebar from '@/components/email/EmailSidebar';

interface EmailMobileNavigationProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onCompose: () => void;
}

const EmailMobileNavigation = ({ 
  isOpen, 
  onOpenChange, 
  onCompose 
}: EmailMobileNavigationProps) => {
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="p-0 w-3/4">
        <EmailSidebar 
          className="h-full" 
          onCompose={onCompose}
          onClose={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
};

export default EmailMobileNavigation;
